// extracted by mini-css-extract-plugin
export default {"wrapper":"carInputUpdate_wrapper__762U9","customInput":"carInputUpdate_customInput__QWSrf"};